export const WELCOME_PATH = '/';
export const CONSIGNOR_LANDING_PATH = '/consignar';
export const HOME_PATH = '/home';
export const RECOVER_PASSWORD_PATH = '/recover-password';
export const RESET_PASSWORD_TOKEN_PATH = '/reset-password/:token/:hash';
export const FINISH_ONBOARDING_PATH = '/finish-onboarding/:token';
export const UPLOAD_INE_PATH = '/upload-ine';
export const ADMIN_HOME_PATH = '/admin/home';
export const ADMIN_INVENTORY_PATH = '/admin/inventory';
/** Estado de inventario administración para “recogida pendiente”; coincide con el API y el sidebar. */
export const ADMIN_INVENTORY_RECOGIDA_STATUS = 'Recogida pendiente';
/** Inventario admin con ese filtro (enlace lateral / marcadores). */
export const ADMIN_INVENTORY_RECOGIDA_PENDIENTE_PATH = `${ADMIN_INVENTORY_PATH}?status=${encodeURIComponent(
  ADMIN_INVENTORY_RECOGIDA_STATUS
)}`;
export const ADMIN_INVENTORY_ADD_PATH = '/admin/inventory/agregar';
export const ADMIN_SALES_PATH = '/admin/sales';
export const ADMIN_PHOTO_QUEUE_PATH = '/admin/photo-queue';
export const ADMIN_CLEANING_QUEUE_PATH = '/admin/cleaning-queue';
export const ADMIN_CONSIGNORS_PATH = '/admin/consignors';
export const ADMIN_PAYMENTS_PATH = '/admin/payments';
export const CONSIGNOR_INVENTORY_PATH = '/consignor/inventory';
export const CONSIGNOR_SALES_PATH = '/consignor/sales';
export const CONSIGNOR_PROFILE_PATH = '/consignor/profile';
